import { useEffect, useRef, useState } from 'react';
import { useResponsesStore } from '../stores/Responses';
import { findResponse } from '../utils/FormFunctions.ts';
import vans from '../../config/vans.json';
import Image from './Image.tsx';

export default function MyVan() {
    const { responses } = useResponsesStore(state => state);
    const textRef = useRef(null);
    const [isOverflowing, setIsOverflowing] = useState(false);

    const first_name = findResponse(responses, 'first_name') || '';
    const last_name = findResponse(responses, 'last_name') || '';
    const vehicle = findResponse(responses, 'vehicle_type');
    const van = vans.find(v => v.type === vehicle);
    const vanImage = van?.image || 'enq_Class_A_rrnw09';

    useEffect(() => {
        const element = textRef.current;

        if (!element) return;

        const checkOverflow = () => {
            // Force reflow and check overflow
            const isOverflowingNow = element.scrollWidth > element.offsetWidth;
            setIsOverflowing(isOverflowingNow);
        };

        // Initial overflow check
        checkOverflow();

        // Observe changes to the text content
        const observer = new MutationObserver(() => {
            checkOverflow();
        });

        observer.observe(element, { childList: true, characterData: true, subtree: true });

        return () => {
            observer.disconnect();
        };
    }, [first_name, last_name]);

    return (
        <div className="w-full grid items-center justify-center">
            <div className="flex flex-col items-center">
                <div className="z-10">
                    {van ? (
                        <Image
                            src={vanImage}
                            params={{ width: 150, height: 116 }}
                            alt="My van"
                        />
                    ) : (
                        <div className="w-[116px] h-[116px] bg-clay rounded-full"></div>
                    )}
                </div>
                <div className="w-[100px] h-[100px] bg-clay rounded-full mt-[-110px]"></div>
            </div>

            <div className="text-center text-[15px] mt-4">
                <p
                    ref={textRef}
                    className="h-[22.5px] w-[200px] overflow-hidden text-ellipsis whitespace-nowrap relative"
                >
                    { (first_name || last_name) &&
                        <>
                            {first_name}
                            {last_name && (
                                <span
                                    className={` ${
                                        isOverflowing ? 'opacity-0 absolute' : 'opacity-100 relative'
                                    }`}
                                >
                                    {' '}
                                    {last_name}
                                </span>
                            )}
                            's
                        </> 
                    }
                </p>
                <b>{vehicle ? vehicle.replaceAll('_', ' ') : 'your vehicle'}</b>
                <p>electrical system</p>
            </div>
        </div>
    );
}
